<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>عروض الأصناف</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">اضافة صنف</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.name"
                        label="أسم الصنف"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.name')"
                        data-vv-name="name"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.price"
                        label="السعر"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.price')"
                        data-vv-name="price"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.price_dashed"
                        label="السعر الملغي"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.another_price')"
                        data-vv-name="another_price"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_priority"
                        :items="priorities"
                        item-text="name"
                        item-value="id"
                        label="أختر الأولوية"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.priority')"
                        data-vv-name="priority"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <label for="files" class="btn">اختر صورة الصنف</label>
                      <input
                        id="files"
                        @change="change_file($event)"
                        type="file"
                      />
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-textarea
                        name="input-7-1"
                        box
                        label="الوصف ضروري"
                        auto-grow
                        v-model="newItem.description"
                        right
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="edit_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">تعديل صنف</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.name"
                      label="أسم الصنف"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.name')"
                      data-vv-name="name"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.price"
                      label="السعر"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.price')"
                      data-vv-name="price"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.price_dashed"
                      label="السعر الملغي"
                      v-validate="'required'"
                      :error-messages="errors.collect('form3.another_price')"
                      data-vv-name="another_price"
                      data-vv-scope="form3"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_priority_edit"
                      :items="priorities"
                      item-text="name"
                      item-value="id"
                      label="أختر الأولوية"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.priority')"
                      data-vv-name="priority"
                      data-vv-scope="form2"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <label for="files" class="btn">اختر صورة الصنف</label>
                    <input
                      id="files"
                      @change="change_file2($event)"
                      type="file"
                    />
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-textarea
                      name="input-7-1"
                      box
                      label="الوصف ضروري"
                      auto-grow
                      v-model="editedItem.description"
                      right
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click="update('form2')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="offer_items"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>
            <img
              style="width:100px"
              :src="appUrl + 'offers/' + props.item.image"
              alt="image"
            />
          </td>
          <td class="text-xs-right">{{ props.item.name }}</td>
          <td class="text-xs-right">{{ props.item.price }}</td>
          <td class="text-xs-right">{{ props.item.price_dashed }}</td>
          <td class="text-xs-right">
            {{
              props.item.piriorty == 1
                ? "مهم جدا"
                : props.item.piriorty == 2
                ? "مهم"
                : "عادي"
            }}
          </td>
          <td class="text-xs-right">{{ props.item.description }}</td>
          <td class="justify-center layout px-0">
            <v-icon small class="ml-4" @click="editItem(props.item)">
              edit
            </v-icon>
            <v-icon small @click="deleteItem(props.item)">
              delete
            </v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  offer_items,
  add_offer_item,
  update_offer_item,
  delete_offer_item
} from "../config/apiRoute.js";
import { appUrl } from "../config/apiConfig.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    select_priority: {},
    select_priority_edit: {},
    priorities: [],
    file_image: "",
    file_image2: "",
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: "صورة الصنف",
        align: "right",
        value: "name"
      },
      {
        text: "أسم الصنف",
        align: "right",
        value: "name"
      },
      {
        text: "السعر ",
        align: "right",
        value: "name"
      },
      {
        text: "السعر الملغي ",
        align: "right",
        value: "name"
      },
      {
        text: "الاولوية  ",
        align: "right",
        value: "name"
      },
      { text: "الوصف", value: "note", align: "right" },
      { text: "التحكم", value: "control", sortable: false, align: "center" }
    ],
    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    offer_items: [],
    editedItem: {
      id: "",
      name: ""
    },
    newItem: {
      id: "",
      name: ""
    },
    appUrl: ""
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.appUrl = appUrl;
    this.priorities = [
      { id: 1, name: "مهم جدا" },
      { id: 2, name: "مهم" },
      { id: 3, name: "عادي" }
    ];
    this.initialize();
  },

  methods: {
    change_file(event) {
      this.file_image = event.target.files[0];
    },

    change_file2(event) {
      this.file_image2 = event.target.files[0];
    },

    initialize() {
      offer_items().then(response => {
        this.offer_items = response.data;
        this.loading = false;
        this.pagination.totalItems = response.data.length;
      });
    },

    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.editedIndex = this.offer_items.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.name = item.name;
      this.editedItem.description = item.description;
      this.editedItem.price = item.price;
      this.editedItem.price_dashed = item.price_dashed;
      item.piriorty == 1 || item.piriorty == "1"
        ? (this.select_priority_edit = { id: 1, name: "مهم جدا" })
        : "";
      item.piriorty == 2 || item.piriorty == "2"
        ? (this.select_priority_edit = { id: 2, name: "مهم" })
        : "";
      item.piriorty == 3 || item.piriorty == "3"
        ? (this.select_priority_edit = { id: 3, name: "عادي" })
        : "";
      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.offer_items.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_offer_item(frmData2, item.id).then(response => {
            this.loading = false;
            this.offer_items.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          var frmData = new FormData();
          this.newItem.piriorty = this.select_priority.id;
          frmData.append("offer", JSON.stringify(this.newItem));
          frmData.append("file", this.file_image);
          add_offer_item(frmData).then(response => {
            this.offer_items.push(response.data);
            //  this.newItem.name=''
            //  this.newItem.note=''
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
      //   if (this.editedIndex > -1) {
      //     Object.assign(this.offer_items[this.editedIndex], this.editedItem)
      //   } else {
      //     this.offer_items.push(this.editedItem)
      //   }

      // this.close()
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let item_id = this.editedItem.id;
          this.editedItem.piriorty = this.select_priority_edit.id;
          var frmData = new FormData();
          frmData.append("offer", JSON.stringify(this.editedItem));
          this.file_image2 && this.file_image2 != "" && this.file_image2 != null
            ? frmData.append("file", this.file_image2)
            : "";
          update_offer_item(frmData, item_id).then(response => {
            Vue.set(
              this.offer_items,
              this.offer_items.findIndex(f => f.id === item_id),
              response.data
            );
            this.loading = false;
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
